import React from 'react';
import '../css/header.css';
import HeaderOption from './HeaderOption';

function Header() {
  return (
    <div className="header">
      <HeaderOption option="Home" url="/" />|
      <HeaderOption option="Ladder Heroes" url="https://ladderheroes.feardragon.com/" />|
      <HeaderOption option="Stream" url="/stream" />|
      <HeaderOption option="Research" url="/research" />
    </div>
  );
}

export default Header;
